import { create } from "zustand";

/**
 * 비즈니스 알림장 목록 화면 상태 스냅샷 (고객 informList 와 동일 패턴).
 * 상세/글쓰기로 이동하기 직전에 저장해 두고, 뒤로가기로 목록에 돌아왔을 때:
 *   1) 저장된 페이지 수만큼(page * 10)을 같은 검색/필터 조건으로 한 번에 재조회하고
 *   2) 리스트가 그려지면 클릭했던 카드가 화면 중앙에 오도록 스크롤한다.
 * returning 플래그가 없으면(= 일반 진입) 복원하지 않고 새로 조회한다.
 */
export interface BusinessNotifySnapshot {
  /** 스냅샷을 저장한 탭 ("받은 알림장" | "보낸 알림장") */
  tab: string;
  scrollY: number;
  /** 클릭했던 알림(notiRecvSeq) — 복원 시 이 카드 기준 스크롤 (없으면 scrollY 사용) */
  anchorSeq?: number | null;
  page: number;
  filterType: string;
  selectedType: string;
  searchKeyword: string | null;
  searchText: string;
}

interface BusinessNotifyStore {
  returning: boolean;
  snapshot: BusinessNotifySnapshot | null;
  save: (snapshot: BusinessNotifySnapshot) => void;
  /** 복원 1회 소비 — 이후 일반 진입은 새로 조회 */
  consume: () => void;
}

export const useBusinessNotifyStore = create<BusinessNotifyStore>((set) => ({
  returning: false,
  snapshot: null,
  save: (snapshot) => set({ snapshot, returning: true }),
  consume: () => set({ returning: false }),
}));
